import { Auth } from "../../../libs/utilities/helpers/Auth";
import { getAppMenu } from "../../../components/CustomHeader";


export const getTitleFromPath = (path) => {
    const user = Auth.getUser();
    let accessibility = user ?.accessibility.filter(item => item.status);
    const route = path.replace("/", "");
    const matchedMenu = getAppMenu(accessibility).find(item => item.route === route);
    return matchedMenu ? matchedMenu.title : "";
}